/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, inject, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import template from './trigger-edit-page.component.html';

import {AppSharedModule} from '../common/app-shared.module';
import {SignalAdminResourceEditPageBase} from '../common/controller/signal-admin-resource-edit-page-base';
import {TriggerFormLogic, TriggerFormLogicDeps} from './trigger-form-logic';
import {FolderApiService} from '../folder/folder-api.service';
import {AdnTimeShifterService} from '../../components/util/adn-time-shifter.service';
import {LocationApiService} from './location-api.service';
import {SearchApiService} from '../common/controller/search-api.service';
import {TriggerApiService, TriggerModel} from './trigger-api.service';
import {VisitorProfileFieldsApiService} from '../fields/visitor-profile-fields-api.service';
import {TriggerFormComponent} from './trigger-form.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, FormsModule, TriggerFormComponent],
  selector: 'adn-trigger-edit-page',
  template
})
export class TriggerEditPageComponent extends SignalAdminResourceEditPageBase<TriggerModel> {
  formLogic = signal<TriggerFormLogic | null>(null);

  private readonly logicDeps: TriggerFormLogicDeps;

  constructor(
    @Inject(AdnTimeShifterService) adnTimeShifter: any,
    folderApi: FolderApiService,
    searchApi: SearchApiService,
    locationApi: LocationApiService,
    private readonly visitorProfileFieldsApi: VisitorProfileFieldsApiService
  ) {
    super(inject(TriggerApiService), 'trigger');

    this.logicDeps = {
      adnTimeShifter,
      folderApi,
      searchApi,
      visitorProfileFieldsApi: this.visitorProfileFieldsApi,
      locationApi
    };
  }

  protected override initialiseModel(model: TriggerModel): TriggerModel {
    const initialised = super.initialiseModel(model);
    initialised.helpfulCriteria = initialised.helpfulCriteria || [];
    return initialised;
  }

  protected override afterEditingModelReset(model: TriggerModel): void {
    this.formLogic.set(new TriggerFormLogic(model, this.logicDeps));
  }

  protected override afterSave(): void {
    if (this.formLogic()?.settingUp) {
      this.formLogic()?.afterInitAfterSubmit();
    }
  }

  protected override prepareForSubmit(): void {
    this.formLogic()?.onBeforeSubmit();
  }

  onTriggerFormChanged(): void {
    this.markExternalFormDirty();
  }
}
